import { render, staticRenderFns } from "./Layers.vue?vue&type=template&id=08718507&lang=pug"
import script from "./Layers.vue?vue&type=script&lang=js"
export * from "./Layers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports